const bannerMessage =
  "Please note: You may be required to pay duties and taxes when you receive your item in your country.";
const banner = document.createElement("div");
banner.classList.add("banner-message");
banner.innerHTML = bannerMessage;
banner.style.display = "none";
document.querySelector(".question").after(banner);

const agreementCheckbox = document.getElementById("agreement");
const agreementForTextMessagesCheckbox = document.getElementById(
  "agreementForTextMessages"
);

function determineProvinceInput() {
  const country = document.getElementById("country");
  if (document.getElementById("country").value === "US") {
    banner.style.display = "none";
    document.getElementById("zip").required = true;
    document.querySelector("label[for='province']").innerHTML =
      "<span class='required'>*</span> State";
    document
      .getElementById("province")
      .parentNode.querySelector(".caret-icon")
      .classList.remove("hidden");
    document.querySelector("label[for='zip']").innerHTML =
      "<span class='required'>*</span> ZIP code";
    document.getElementById(
      "province"
    ).outerHTML = `<select class="floating__input" id="province">
        <option value="AL">Alabama</option>
        <option value="AK">Alaska</option>
        <option value="AZ">Arizona</option>
        <option value="AR">Arkansas</option>
        <option value="CA">California</option>
        <option value="CO">Colorado</option>
        <option value="CT">Connecticut</option>
        <option value="DE">Delaware</option>
        <option value="DC">District Of Columbia</option>
        <option value="FL">Florida</option>
        <option value="GA">Georgia</option>
        <option value="HI">Hawaii</option>
        <option value="ID">Idaho</option>
        <option value="IL">Illinois</option>
        <option value="IN">Indiana</option>
        <option value="IA">Iowa</option>
        <option value="KS">Kansas</option>
        <option value="KY">Kentucky</option>
        <option value="LA">Louisiana</option>
        <option value="ME">Maine</option>
        <option value="MD">Maryland</option>
        <option value="MA">Massachusetts</option>
        <option value="MI">Michigan</option>
        <option value="MN">Minnesota</option>
        <option value="MS">Mississippi</option>
        <option value="MO">Missouri</option>
        <option value="MT">Montana</option>
        <option value="NE">Nebraska</option>
        <option value="NV">Nevada</option>
        <option value="NH">New Hampshire</option>
        <option value="NJ">New Jersey</option>
        <option value="NM">New Mexico</option>
        <option value="NY">New York</option>
        <option value="NC">North Carolina</option>
        <option value="ND">North Dakota</option>
        <option value="OH">Ohio</option>
        <option value="OK">Oklahoma</option>
        <option value="OR">Oregon</option>
        <option value="PA">Pennsylvania</option>
        <option value="RI">Rhode Island</option>
        <option value="SC">South Carolina</option>
        <option value="SD">South Dakota</option>
        <option value="TN">Tennessee</option>
        <option value="TX">Texas</option>
        <option value="UT">Utah</option>
        <option value="VT">Vermont</option>
        <option value="VA">Virginia</option>
        <option value="WA">Washington</option>
        <option value="WV">West Virginia</option>
        <option value="WI">Wisconsin</option>
        <option value="WY">Wyoming</option>
        <option disabled>US Outlying Territories</option>
        <option value="AS">American Samoa</option>
        <option value="GU">Guam</option>
        <option value="MP">Northern Mariana Islands</option>
        <option value="PR">Puerto Rico</option>
        <option value="UM">United States Minor Outlying Islands</option>
        <option value="VI">Virgin Islands</option>
        <option disabled>Armed Forces</option>
        <option value="AA">Armed Forces Americas</option>
        <option value="AP">Armed Forces Pacific</option>
        <option value="AE">Armed Forces Others</option>
        </select>`;
  } else if (country.value === "PH" || country.value === "VI") {
    document.getElementById("zip").required = true;
    document.querySelector("label[for='zip']").innerHTML =
      "<span class='required'>*</span> ZIP code";
    const tempCaret = document
      .getElementById("province")
      .parentNode.querySelector(".caret-icon");
    tempCaret.classList.add("hidden");
    document.getElementById(
      "province"
    ).parentNode.innerHTML = `<input class="floating__input" id="province" type="text" placeholder="Province"> <label class="floating__label" for="province">Province</label>`;
    document.querySelector("label[for='province']").innerHTML = "Province";
    document.getElementById("province").parentNode.append(tempCaret);
  } else {
    banner.style.display = "block";
    window.scrollTo({ top: banner.offsetTop, behavior: "smooth" });
    // Remove required asterisk from State/Province and Postal Code label.
    const tempCaret = document
      .getElementById("province")
      .parentNode.querySelector(".caret-icon");
    tempCaret.classList.add("hidden");
    document.getElementById(
      "province"
    ).parentNode.innerHTML = `<input class="floating__input" id="province" type="text" placeholder="Province"> <label class="floating__label" for="province">Province</label>`;
    document.getElementById("province").parentNode.append(tempCaret);
    document.querySelector("label[for='province']").innerHTML = "Province";
    document.getElementById("zip").required = false;
    document.getElementById("zip").classList.remove("invalid");
    // In case previous validation was for a country where ZIP code is required,
    // we want to remove red border when changed to a country where this field is not required
    document.querySelector("label[for='zip']").innerHTML = "Postal code";
    document.getElementById(
      "zip"
    ).innerHTML = `<input class="floating__input" id="zip" type="text">`;
  }
}

function removeClass() {
  this.classList.remove("invalid");
}

document.getElementById("submit-repair").addEventListener("click", (event) => {
  event.preventDefault();
  requiredFields().then((filledOut) => {
    if (filledOut) {
      isMatching().then((matching) => {
        const { emailsMatch, phoneNumbersMatch } = matching;
        if (!emailsMatch) {
          document.title = "Error: Emails do not match.";
          document.getElementsByClassName(
            "question"
          )[0].innerHTML = `<b>ERROR: Emails do not match.</b>`;
          document.getElementById("submit-repair").style.display = "none";
          agreementCheckbox.checked = false;
          agreementForTextMessagesCheckbox.checked = false;
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0;
          return;
        } else if (!phoneNumbersMatch) {
          document.title = "Error: Phone numbers do not match.";
          document.getElementsByClassName(
            "question"
          )[0].innerHTML = `<b>ERROR: Phone numbers do not match.</b>`;
          document.getElementById("submit-repair").style.display = "none";
          agreementCheckbox.checked = false;
          agreementForTextMessagesCheckbox.checked = false;
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0;
          return;
        } else {
          document.getElementById(
            "submit-repair"
          ).innerHTML = `Processing. This can take a minute! <span uk-spinner></span>`;
          const serviceCart = JSON.parse(Cookies.get("serviceCartCheckout"));
          const temporary = serviceCart;
          const formData = document.forms["checkout-form"];
          const clientData = {
            firstName: formData["first-name"].value,
            lastName: formData["last-name"].value,
            email1: formData.email.value.toUpperCase(),
            email2: formData["confirm-email"].value.toUpperCase(),
            phone1: formData.phone.value,
            phone2: formData["confirm-phone"].value,
            address: {
              address1: formData.address.value,
              address2: formData.address2.value,
              city: formData.city.value,
              province: formData.province.value,
              country: formData.country.value,
              zip: formData.zip.value,
            },
            serialNumber:
              formData.serial.value.length > 0 ? formData.serial.value : "N/A",
            notes: formData.notes.value,
            TotalVariantWeight: Math.round(
              Number(serviceCart.totalWeight) * 0.035274
            ),
            variantId: serviceCart.variantList,
            productIdList: serviceCart.productIdList,
            uuid: serviceCart.uuid,
            contactPreference: formData["communication"].value,
          };
          Cookies.set("serviceCartCheckout", JSON.stringify(temporary), {
            sameSite: "none",
            secure: true,
          });
          console.log(clientData);
          axios
            .post(
              "https://easyshipcsharp.azurewebsites.net/api/Validation",
              clientData
            )
            .then((result) => {
              console.log(result);
              window.location = result.data;
            })
            .catch((error) => {
              window.location.href =
                "/pages/repair-service-finished?error=true";
            });
        }
      });
    } else {
      return;
    }
  });
});

let autocomplete;
address1Field = document.getElementById("address");
address2Field = document.getElementById("address2");
postalField = document.getElementById("zip");

function initAutocomplete() {
  autocomplete = new google.maps.places.Autocomplete(address1Field, {
    componentRestrictions: {
      country: "us",
    },
    fields: ["address_components"],
    types: ["address"],
  });

  autocomplete.addListener("place_changed", fillInAddress);
}

function fillInAddress() {
  // Get the place details from the autocomplete object.
  const place = autocomplete.getPlace();
  let address1 = "";
  let postcode = "";

  // Get each component of the address from the place details,
  // and then fill-in the corresponding field on the form.
  // place.address_components are google.maps.GeocoderAddressComponent objects
  // which are documented at http://goo.gle/3l5iMr
  for (const component of place.address_components) {
    const componentType = component.types[0];
    switch (componentType) {
      case "street_number": {
        address1 = `${component.long_name} ${address1}`;
        break;
      }

      case "route": {
        address1 += component.short_name;
        break;
      }

      case "postal_code": {
        postcode = component.long_name;
        break;
      }

      case "locality": {
        document.getElementById("city").value = component.long_name;
        break;
      }

      case "administrative_area_level_1": {
        document.getElementById("province").value = component.short_name;
        break;
      }

      case "country": {
        document.getElementById("country").value = component.short_name;
        break;
      }
    }
    address1Field.value = address1;
    postalField.value = postcode;
    // After filling the form with address components from the Autocomplete
    // prediction, set cursor focus on the second adress line to encourage
    // entry of subpremise information such as apartment, unit, or floor number.
    address2Field.focus();
  }
}

function requiredFields() {
  return new Promise((resolve) => {
    let filledOut = true;
    document
      .querySelectorAll("input[required], select[required], textarea[required]")
      .forEach((requiredInput) => {
        if (
          requiredInput.value === "" ||
          typeof requiredInput.value === "undefined"
        ) {
          requiredInput.classList.add("invalid");
          document.title = "Error: Didn't fill out all required fields.";
          document.getElementsByClassName(
            "question"
          )[0].innerHTML = `<b>ERROR: Did not fill out all required fields.</b>`;
          document.getElementById("submit-repair").style.display = "none";
          agreementCheckbox.checked = false;
          agreementForTextMessagesCheckbox.checked = false;
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0;
          filledOut = false;
        } else {
          requiredInput.classList.remove("invalid");
        }
      });
    resolve(filledOut);
  });
}

function validateCheckboxes() {
  if (agreementCheckbox.checked && agreementForTextMessagesCheckbox.checked) {
    document.getElementById("submit-repair").style.display = "flex";
  } else {
    document.getElementById("submit-repair").style.display = "none";
  }
}

function isMatching() {
  return new Promise((resolve) => {
    const email = document.getElementById("email").value.toUpperCase();
    const confirmEmail = document
      .getElementById("confirm-email")
      .value.toUpperCase();
    const phone = document.getElementById("phone").value;
    const confirmPhone = document.getElementById("confirm-phone").value;
    let emailsMatch = false;
    let phoneNumbersMatch = false;
    if (email === confirmEmail && email !== "") {
      emailsMatch = true;
      document.getElementById("email").classList.remove("invalid");
      document.getElementById("confirm-email").classList.remove("invalid");
    } else {
      document.getElementById("email").classList.add("invalid");
      document.getElementById("confirm-email").classList.add("invalid");
    }
    if (phone === confirmPhone && phone !== "") {
      phoneNumbersMatch = true;
      document.getElementById("phone").classList.remove("invalid");
      document.getElementById("confirm-phone").classList.remove("invalid");
    } else {
      document.getElementById("phone").classList.add("invalid");
      document.getElementById("confirm-phone").classList.add("invalid");
    }
    resolve({
      emailsMatch,
      phoneNumbersMatch,
    });
  });
}
